import {
    type AuditTrailFilterValues,
    AuditTrailView,
    orgAuditTrailConfiguration,
} from '@client/components/_business/audit-trail';
import { PageController } from '@client/components/_core/layout/PageController';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { usePathState } from '@client/hooks/navigation/usePathState';
import type { RouterInputs } from '@client/trpc/client';
import { DEFAULT_PAGE_SIZE } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { History } from 'lucide-react';
import { useState } from 'react';

export const Route = createFileRoute('/console/$orgId/configuration/monitoring/audit-trail')({
    staticData: {
        breadcrumb: {
            title: 'Audit trail',
        },
        permissions: ['audit_trail:read'],
        ui: {
            icon: History,
            title: 'Audit trail',
            subtitle: 'View administrative actions within your organisation',
            menuDescription: 'Review system activity and changes',
            widthVariant: 'fullWidth',
        },
    },
    component: OrgAuditTrailPage,
});

type QueryVariables = RouterInputs['auditTrail']['listOrgAuditTrail'];

function OrgAuditTrailPage() {
    const { trpc } = useTrpc();

    const [filters, setFilters] = useState<AuditTrailFilterValues>({});

    const [queryVariables, setQueryVariables] = usePathState<QueryVariables>('queryVariables', {
        limit: DEFAULT_PAGE_SIZE,
    });

    const { data, refetch, isFetching, error } = trpc.auditTrail.listOrgAuditTrail.useQuery(
        {
            ...queryVariables,
            ...filters,
        },
        { meta: { errorSurface: 'inline' } },
    );

    return (
        <PageController route={Route}>
            <AuditTrailView
                configuration={orgAuditTrailConfiguration}
                data={data?.items}
                total={data?.total}
                error={error}
                isFetching={isFetching}
                queryVariables={queryVariables}
                onFiltersChange={setFilters}
                onQueryVariablesChange={setQueryVariables}
                onRefresh={() => refetch()}
            />
        </PageController>
    );
}
